import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { isAdmin, fmtDate } from "../../lib/customers";
import { Button } from "../ui/button";

export const TransferPanel = ({ onDone }) => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/customer-transfers").then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const decide = async (t, approve) => {
    try { await api.post(`/customer-transfers/${t.id}/decide`, { approve }); toast.success(approve ? "Approved" : "Rejected"); load(); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  if (!items.length) return null;
  return (
    <div className="mt-6 rounded-xl border border-amber-200 bg-amber-50/60 p-4" data-testid="transfer-panel">
      <div className="text-sm font-semibold text-amber-900 mb-2">Customer Link / Transfer Requests ({items.length})</div>
      <div className="space-y-2">
        {items.map((t) => (
          <div key={t.id} className="flex flex-wrap items-center justify-between gap-2 bg-white rounded-md border border-amber-100 p-3 text-sm" data-testid={`transfer-${t.id}`}>
            <div>
              <b>{t.customer_name}</b> ({t.customer_code}) · {t.type === "link" ? "Link" : "Transfer"}: {t.from_branch} → <b>{t.to_branch}</b>
              <div className="text-xs text-slate-500">by {t.requested_by} · {fmtDate(t.created_at, true)}</div>
            </div>
            {isAdmin() ? (
              <div className="flex gap-2">
                <Button size="sm" className="bg-green-600 hover:bg-green-700 text-white" onClick={() => decide(t, true)} data-testid={`transfer-approve-${t.id}`}>Approve</Button>
                <Button size="sm" variant="outline" className="text-red-600" onClick={() => decide(t, false)} data-testid={`transfer-reject-${t.id}`}>Reject</Button>
              </div>
            ) : <span className="text-xs text-slate-500">Admin approval pending</span>}
          </div>
        ))}
      </div>
    </div>
  );
};
